import { memo, useCallback } from 'react';
import Grid, { IGridProps } from '../Grid';
import Tooltip from '../Tooltip';
import Typography from '../Typography';
import { CopyIcon } from '../../icons';
import { AB3, S2 } from '../../theme';
import ButtonBase from '../ButtonBase';

export interface ICopyableTextProps extends Omit<IGridProps, 'onCopy'> {
  text: string;
  onCopy: (text: string) => void | Promise<void>;
  tooltipTitle: string;
}

const BUTTON_SX = {
  borderRadius: 2,
  paddingTop: 0.25,
  paddingRight: 0.25,
  paddingLeft: 0.5,
  '&:hover': {
    background: S2,
  },
};
const TYPOGRAPHY_SX = {
  wordBreak: 'break-all',
};

const CopyableText = (props: ICopyableTextProps) => {
  const {
    text, onCopy, tooltipTitle, ...rest
  } = props;

  const handleCopyButtonClick = useCallback(() => {
    onCopy(text);
  }, [text, onCopy]);

  return (
    <Tooltip title={tooltipTitle} cursorPointer>
      <ButtonBase sx={BUTTON_SX}>
        <Grid container {...rest} onClick={handleCopyButtonClick}>
          <Grid item xs>
            <Typography sx={TYPOGRAPHY_SX} color={AB3} variant="subtitle1">{text}</Typography>
          </Grid>
          <Grid item alignSelf="flex-start" ml={1} mt={-0.25}>
            <CopyIcon width={24} height={24} color={AB3} />
          </Grid>
        </Grid>
      </ButtonBase>
    </Tooltip>
  );
};

export default memo(CopyableText);
